'use client';

import { m, domMax, LazyMotion, MotionConfig } from 'framer-motion';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function MotionLazy({ children }: Props) {
  return (
    <MotionConfig reducedMotion="user">
      <LazyMotion strict features={domMax}>
        <m.div style={{ height: '100%' }}> {children} </m.div>
      </LazyMotion>
    </MotionConfig>
  );
}
